import React from 'react'

const Lights = () => {
    
    return (
       <>
        <ambientLight intensity = {0.8}/>
        <hemisphereLight intensity={1} color = "#ffffff"  groundColor="#AEAEAE" position= {[0,5, 0]}/>
       </>
    )
}

export default Lights
